import { APIService } from '../api/APIService'

import {
  FETCH_USER,
  FETCH_IMAGE,
  UPDATE_PROFILE
} from './types/actions.type'

import {
  SET_LOADING,
  SET_USER,
  SET_ERROR
} from './types/mutations.type'

const api = new APIService()

const state = {
  errors: null,
  user: {},
  company: {},
  profile_picture: '',
  isLoading: false
}

const getters = {
  getProfilePicture(state) {
    return state.profile_picture
  }
}

const actions = {
  [FETCH_USER](context, userId) {
    return new Promise((resolve, reject) => {
      api.getUserDetails(userId).then(data => {
        context.commit(SET_LOADING, false)
        if(data.statusCode === 400) context.commit(SET_ERROR, data)
        else {
          context.commit(SET_USER, data)
          resolve(data)
        }
      }).catch(err => {
        context.commit(SET_ERROR, err)
      })
    })
  },
  [FETCH_IMAGE](context, obj) {
    return new Promise((resolve, reject) => {
      api.fetchImage(obj)
        .then(data => { resolve(data) })
        .catch(err => { context.commit(SET_ERROR, err) })
    })
  },
  [UPDATE_PROFILE](context, { id, fields }) {
    return new Promise((resolve, reject) => {
      api.updateProfile(id, fields)
        .then(data => { resolve(data) })
        .catch(err => { context.commit(SET_ERROR, err) })
    })
  }
}

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error
  },
  [SET_LOADING](state, loading) {
    state.isLoading = loading
  },
  [SET_USER](state, user) {
    state.user = user
    state.errors = null
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/profile.module.js